function stopOwlPropagation(element) {
    $(element).on("to.owl.carousel", function(e) { e.stopPropagation(); });
    $(element).on("next.owl.carousel", function(e) { e.stopPropagation(); });
    $(element).on("prev.owl.carousel", function(e) { e.stopPropagation(); });
    $(element).on("destroy.owl.carousel", function(e) { e.stopPropagation(); });
}
stopOwlPropagation(".owl-carousel");